<div class="recurrence-panel">

    <div class="panel-header">
        <span class="material-icons-outlined">event_busy</span>
        <span class="panel-title">{{ "recurrence.cancel.title" | translate }}</span>
    </div>

    <div class="panel-body" *ngIf="!loading; else busy">

        <p class="intro" *ngIf="hasFuture">
            {{ "recurrence.cancel.intro" | translate: { count: count } }}
        </p>
        <p class="intro" *ngIf="!hasFuture">
            {{ "recurrence.cancel.introNone" | translate }}
        </p>

        <ul class="affected" *ngIf="hasFuture">
            <li *ngFor="let one of (impact | async)?.future">
                <!-- the number alone: the word would be the same word on every
                     row, and the column is narrow enough already -->
                <span class="occurrence">
                    {{ one.sequence }}<ng-container *ngIf="!seriesUnbounded"> {{
                    "recurrence.details.of" | translate }} {{ seriesTotal }}</ng-container>
                </span>
                <span class="title">{{ one.title }}</span>
                <span class="notes"></span>
                <span class="scheduled">{{ one.scheduledOn }}</span>
                <span class="warning">
                    <span class="material-icons-outlined" *ngIf="one.hasActivity"
                          [title]="'recurrence.cancel.hasActivity' | translate">warning</span>
                </span>
            </li>
        </ul>

        <div class="choices" *ngIf="hasFuture">
            <label class="option" [class.on]="future === 'keep'">
                <input type="radio" name="future" value="keep" [(ngModel)]="future" />
                <span>{{ "recurrence.cancel.keep" | translate }}</span>
            </label>

            <label class="option" [class.on]="future === 'delete'">
                <input type="radio" name="future" value="delete" [(ngModel)]="future" />
                <span>{{ "recurrence.cancel.delete" | translate }}</span>
            </label>
        </div>

        <p class="warning-note" *ngIf="future === 'delete' && (impact | async)?.anyTouched">
            {{ "recurrence.cancel.hasActivity" | translate }}
        </p>

        <div class="panel-actions">
            <button type="button" class="btn-abort" (click)="abort()">
                {{ "recurrence.cancel.abort" | translate }}
            </button>
            <button type="button" class="btn-confirm" (click)="confirm()">
                {{ "recurrence.cancel.confirm" | translate }}
            </button>
        </div>
    </div>

    <ng-template #busy>
        <p class="panel-body">{{ "recurrence.change.loading" | translate }}</p>
    </ng-template>
</div>
